import React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";
import { TYPO } from "../typography";
import { COLORS } from "theme/tokens";

// ──────────────────────────────────────────────────────────────────────────
// 配額卡（對齊截圖三 layout）：icon 在上、文字在下
//   icon      : PNG 路徑（左上角灰底框內）
//   label     : 卡片名稱（左下）
//   remaining : 剩餘數字（右下，大橘字）
//   limit     : 總額度（-1 = 無限 → ∞）
//   tooltip   : ⓘ 滑過顯示的說明文字
// 共用於「我的精靈策略」頁與許願流程各步驟，確保樣式一致（單一來源）
// ──────────────────────────────────────────────────────────────────────────
export default function QuotaCard({ icon, label, remaining, limit, tooltip, remainingLabel = "剩餘" }) {
  const limitText = limit === -1 ? "∞" : (limit ?? "—");
  return (
    <div
      className="bg-white flex justify-between"
      style={{
        borderRadius: 16,
        border: "1px solid #EEF0F4",
        boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
        padding: "clamp(10px, 1.6vh, 14px) 20px",
        minHeight: "clamp(76px, 12vh, 92px)",
        alignItems: "stretch",
      }}
    >
      {/* 左欄：icon（上）＋ label（下）*/}
      <div className="flex flex-col justify-between">
        <div
          className="shrink-0 flex items-center justify-center"
          style={{ width: 50, height: 50, padding: 8, borderRadius: 12, background: COLORS.grayLightest, boxSizing: "border-box" }}
        >
          <img src={icon} alt="" style={{ width: 34, height: 34, padding: 2, boxSizing: "border-box", objectFit: "contain", flexShrink: 0 }} />
        </div>
        <span style={{ ...TYPO.headingM, color: "#0A0A0A" }}>
          {label}
        </span>
      </div>

      {/* 右欄：剩餘+ⓘ（緊貼數字上方）＋ 數字，整組靠下對齊 */}
      <div className="flex flex-col" style={{ alignItems: "flex-end", justifyContent: "flex-end", gap: 4 }}>
        <span
          style={{
            ...TYPO.bodyM,
            color: COLORS.grayDark,
            fontWeight: 500,
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <MuiTooltip
            arrow
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            title={tooltip || ""}
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: COLORS.lighter,
                  color: COLORS.black,
                  border: "1px solid #F36D26",
                  fontFamily: 'var(--cjk-font, "Noto Sans TC"), sans-serif',
                  fontSize: 13,
                  fontWeight: 500,
                  px: 1.5,
                  py: 1,
                  borderRadius: 2,
                },
              },
              arrow: { sx: { color: COLORS.lighter, "&::before": { border: "1px solid #F36D26" } } },
            }}
          >
            <img src="/images/icon/genie/info-icon.png" alt="info" style={{ width: 16, height: 16, cursor: "pointer" }} />
          </MuiTooltip>
          {remainingLabel}
        </span>
        <span style={{ fontFamily: "Outfit, sans-serif", lineHeight: 1, whiteSpace: "nowrap" }}>
          <span style={{ ...TYPO.numQuota, color: COLORS.main }}>{remaining ?? "—"}</span>
          <span style={{ color: "#CBD5E1", fontSize: 16, fontWeight: 500, marginLeft: 2 }}>/ {limitText}</span>
        </span>
      </div>
    </div>
  );
}
